import { computed } from 'vue';

export const formFieldMixin = {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            default: null,
        },
        error: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            default: null,
        },
    },
    computed: {
        state() {
            if (this.error) {
                return !this.error;
            }
        },
        attrs() {
            const { state, ...attrs } = this.$attrs;
            return attrs;
        },
        listeners() {
            const { input, ...listeners } = this.$listeners;
            return listeners;
        },
    },
    methods: {
        input(value) {
            this.$emit('input', value);
        },
    },
};

export const useFormFieldMixin = (props) => {
    const state = computed(() => {
        if (props.error) {
            return !props.error;
        }
    });

    const attrs = computed(() => {
        const { state, ...attrs } = props;
        return attrs;
    });

    const listeners = computed(() => {
        const { input, ...listeners } = props;
        return listeners;
    });

    const input = (value) => {
        emit('input', value);
    };

    return {
        state,
        attrs,
        listeners,
    };
};
